import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { Fab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React, { useEffect, useState } from "react";
import "../Styles/CertificateType.scss";
import { baseUrl, mainBaseUrl } from "../../App";
import axios from "axios";
import loaderimg from "../../Images/InsistentTautGodwit-small.gif";
const CertificateType = () => {
  const [certData, setCertData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [openup, setOpenup] = React.useState(false);
  const [code, SetCode] = React.useState("");
  const [codeFull, SetCodeFull] = React.useState("");
  const [updatecodes, SetUpdateCodes] = React.useState("");
  const [updatecodeFull, SetupdatecodeFull] = React.useState("");

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseup = () => {
    setOpenup(false);
  };
  const handleClickOpenup = () => {
    setOpenup(true);
  };

  const deleteCode = (prevCode) => {
    axios
      .delete(`${mainBaseUrl}/certificateType/${prevCode}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "API-Key": baseUrl,
        },
      })
      .then(() => getCertificateType());
  };

  const updateCode = (prevCode) => {
    axios
      .patch(
        `${mainBaseUrl}/certificateType/${prevCode}`,
        {
          typeCode: updatecodes,
          certificateType: updatecodeFull,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "API-Key": baseUrl,
          },
        }
      )
      .then(handleCloseup)
      .then(() => getCertificateType())
      .catch((e) => alert(e.response.statusText));
  };

  const getCertificateType = () => {
    var config = {
      method: "get",
      url: `${mainBaseUrl}/certificateType`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };
    axios(config)
      .then(function (response) {
        setCertData(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const addCode = () => {
    axios
      .post(
        `${mainBaseUrl}/certificateType`,
        {
          typeCode: code,
          certificateType: codeFull,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "API-Key": baseUrl,
          },
        }
      )
      .then(handleClose)
      .then(() => getCertificateType())
      .catch((e) => alert(e.response.statusText));
  };

  useEffect(() => {
    getCertificateType();
  }, []);

  if (certData === null) {
    return (
      <div className="imgContainer">
        <p>Loading...</p>
        {/* <img className="gif" src={loaderimg} alt="" /> */}
      </div>
    );
  }
  return (
    <div className="main">
      <Fab color="primary" className="floatingAction" aria-label="add">
        <AddIcon onClick={handleClickOpen} />
      </Fab>
      <div className="containersType">
        {certData.map((cert, index) => {
          return (
            <div key={index} className="containerType">
              <p>
                Certificate Type: <b>{cert["certificateType"]}</b>
              </p>
              <p>
                Certificate Code: <b>{cert["typeCode"]} </b>
              </p>
              <button onClick={handleClickOpenup} className="btnType">
                Update
              </button>
              <button
                onClick={() => {
                  deleteCode(cert["typeCode"]);
                }}
                className="btnType"
              >
                Delete
              </button>
              <Dialog
                open={openup}
                onClose={handleCloseup}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">
                  Update Certificate Type
                </DialogTitle>

                <DialogContent>
                  <TextField
                    margin="dense"
                    label="TypeCode"
                    type="text"
                    variant="outlined"
                    onChange={(e) => SetUpdateCodes(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    margin="dense"
                    label="Type Code FullForm"
                    type="text"
                    variant="outlined"
                    onChange={(e) => SetupdatecodeFull(e.target.value)}
                    fullWidth
                  />
                  <Button
                    onClick={() => {
                      updateCode(cert["typeCode"]);
                    }}
                    variant="contained"
                    style={{
                      backgroundColor: "#200e32",
                      color: "white",
                    }}
                  >
                    Update Type Code
                  </Button>
                </DialogContent>
              </Dialog>
            </div>
          );
        })}
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Certificate Type</DialogTitle>

        <DialogContent>
          <TextField
            margin="dense"
            label="TypeCode"
            type="text"
            variant="outlined"
            onChange={(e) => SetCode(e.target.value)}
            fullWidth
          />
          <TextField
            margin="dense"
            label="Type Code FullForm"
            type="text"
            variant="outlined"
            onChange={(e) => SetCodeFull(e.target.value)}
            fullWidth
          />
          <Button
            onClick={addCode}
            variant="contained"
            style={{
              backgroundColor: "#200e32",
              color: "white",
            }}
          >
            Add Type Code
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CertificateType;
